import { render, staticRenderFns } from "./updateUser.vue?vue&type=template&id=0f4a4177"
import script from "./updateUser.vue?vue&type=script&lang=js"
export * from "./updateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports